import {MESSAGE_COUNT, MESSAGE_TAB_OPTIONS} from './Index';
import {getUserDashboardMessagesCardData} from '../../services/MetricsServices';

export const _messageCount = (groupId: any): any => async (dispatch: any) => {
  getUserDashboardMessagesCardData({
    groupId: groupId
  }).then((res: any) => {
    let total = 0;
    if (res?.data?.rows) {
      for (const msgData of res.data.rows) {
        if (msgData.unread_messages) {
          total = total + parseInt(msgData.unread_messages);
        }
      }
    }
    dispatch({type: MESSAGE_COUNT, payload: {count: total, groupId}});
  });
};

export const _setMessageTabOptions = (payload: any): any => async (
  dispatch: any
) => {
  dispatch({type: MESSAGE_TAB_OPTIONS, payload: payload});
};
